import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Globe, Phone, TrendingUp, Lock, Code2, Gift, Zap } from 'lucide-react';
import './ServicePages.css';
import { fadeInUp } from '../constants/animations';

function Services() {
  const services = [
    {
      title: 'Custom Design',
      desc: 'Premium websites built to convert and rank locally.',
      link: '/services/custom-design',
      icon: Globe
    },
    {
      title: 'AI Phone Assistant',
      desc: 'AI answers every call and captures every lead.',
      link: '/services/ai-phone-assistant',
      icon: Phone
    },
    {
      title: 'Business Phone Line',
      desc: 'Professional business line with smart routing.',
      link: '/services/business-phone',
      icon: TrendingUp
    },
    {
      title: 'Client Portals & Forms',
      desc: 'Streamline onboarding, quotes, and jobs.',
      link: '/services/client-portals',
      icon: Lock
    },
    {
      title: 'Web Apps',
      desc: 'Custom tools tailored to your operations.',
      link: '/services/web-apps',
      icon: Code2
    },
    {
      title: 'Rewards Program',
      desc: 'Drive referrals and repeat business automatically.',
      link: '/services/rewards',
      icon: Gift
    },
    {
      title: 'Square Integrations',
      desc: 'Payments, invoicing, and automations connected.',
      link: '/services/square-integrations',
      icon: Zap
    }
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.08,
        delayChildren: 0.1
      }
    }
  };

  return (
    <main className="service-page">
      <div className="service-container">
        <motion.div 
          className="service-hero" 
          initial="hidden" 
          whileInView="visible" 
          viewport={{ once: true, amount: 0.5 }}
          variants={containerVariants}
        >
          <motion.h1 variants={fadeInUp}>Services</motion.h1>
          <motion.p variants={fadeInUp}>Everything you need to grow local visibility, capture leads, and automate follow‑up — handled by one team.</motion.p>
        </motion.div>

        <motion.div 
          className="service-grid"
          initial="hidden" 
          whileInView="visible" 
          viewport={{ once: true, amount: 0.1 }}
          variants={containerVariants}
        >
          {services.map((service) => {
            const Icon = service.icon;
            return (
              <motion.div key={service.title} variants={fadeInUp}>
                <Link to={service.link} className="service-card">
                  <div className="service-icon">
                    <Icon size={28} />
                  </div>
                  <h3>{service.title}</h3>
                  <p>{service.desc}</p>
                </Link>
              </motion.div>
            );
          })}
        </motion.div>

        <motion.div 
          className="service-block" 
          initial="hidden" 
          whileInView="visible" 
          viewport={{ once: true, amount: 0.5 }} 
          variants={fadeInUp}
        >
          <h3>One price. Everything included.</h3>
          <p>We handle the technology, setup, and ongoing support so you can focus on running your business.</p>
        </motion.div>

        <motion.div 
          className="service-cta" 
          initial="hidden" 
          whileInView="visible" 
          viewport={{ once: true, amount: 0.5 }} 
          variants={fadeInUp}
        >
          <Link to="/plans">Get Started</Link>
        </motion.div>
      </div>
    </main>
  );
}

export default Services;
